import * as React from 'react';
import { withRouteData } from 'react-static';

import TechnicalPageComponent from '../../components/TechnicalPage/TechnicalPage';
import { TechnicalPageLocale } from '../../components/TechnicalPage/technicalPage.locale';

interface TechnicalPageProps {
  locale: TechnicalPageLocale;
}

const TechnicalPage: React.SFC<TechnicalPageProps> = ({ locale }) => (
  <TechnicalPageComponent locale={locale} />
);

export default withRouteData(TechnicalPage);



// WEBPACK FOOTER //
// /www/client/src/containers/TechnicalPage/TechnicalPage.tsx